// Shared caption style constants used by ClipCard, ClipEditor, MePage, and burnCaption.js

// Caption color presets (UI uses dot/border; canvas burn uses bg/text)
export const HOOK_COLORS = [
  { id: "white",  bg: "rgba(255,255,255,0.92)", text: "#111",  dot: "#fff",    border: "#bbb" },
  { id: "black",  bg: "rgba(0,0,0,0.85)",       text: "#fff",  dot: "#222",    border: "#555" },
  { id: "yellow", bg: "rgba(255,235,59,0.95)",   text: "#111",  dot: "#FFEB3B", border: "#FDD835" },
  { id: "red",    bg: "rgba(239,68,68,0.92)",    text: "#fff",  dot: "#EF4444", border: "#DC2626" },
  { id: "blue",   bg: "rgba(59,130,246,0.92)",   text: "#fff",  dot: "#3B82F6", border: "#2563EB" },
  { id: "green",  bg: "rgba(34,197,94,0.92)",    text: "#fff",  dot: "#22C55E", border: "#16A34A" },
];

// Caption font presets (loaded via Google Fonts in CSS)
export const HOOK_FONTS = [
  { id: "montserrat", label: "Montserrat", family: "'Montserrat', sans-serif" },
  { id: "bebas",      label: "Bebas Neue", family: "'Bebas Neue', sans-serif" },
  { id: "oswald",     label: "Oswald",     family: "'Oswald', sans-serif" },
  { id: "bangers",    label: "Bangers",    family: "'Bangers', cursive" },
  { id: "marker",     label: "Marker",     family: "'Permanent Marker', cursive" },
  { id: "anton",      label: "Anton",      family: "'Anton', sans-serif" },
  { id: "poppins",    label: "Poppins",    family: "'Poppins', sans-serif" },
];

// Keyed maps for canvas rendering in burnCaption.js
export const COLOR_MAP = Object.fromEntries(
  HOOK_COLORS.map(c => [c.id, { bg: c.bg, text: c.text }])
);

export const FONT_MAP = Object.fromEntries(
  HOOK_FONTS.map(f => [f.id, f.family])
);
